export enum AccountOptionType {
  EDIT = 'Edit',
  ACTIVATE = 'Activate',
  DEACTIVATE = 'Deactivate',
  RESEND_PASSWORD = 'ResendPassword',
}
